import React from 'react';

import { format } from 'date-fns';

import ActualVsBudgetReportDetailedTable from './ActualVsBudgetReportDetailedTable';
import ActualVsBudgetReportSummaryTable from './ActualVsBudgetReportSummaryTable';
import { useActualVsBudgetReportContext } from './context/ActualVsBudgetReportContext';
import DepartmentActualVsBudgetReportDetailedTable from './DepartmentActualVsBudgetReportDetailedTable';
import { TYPE_EVENT } from './types/ModuleType';
import { TYPE_DETAILED, TYPE_SUMMARY } from './types/ReportType';

import Button from 'CommonComponents/Button';

import { useToast } from 'Hooks/useToast';

import RefreshIcon from 'Assets/icons/refresh-sync.svg';

const ActualVsBudgetReportTable = () => {
    const toast = useToast();

    const { module, summary, details, viewType, isGenerating, generationTime, refreshReport } = useActualVsBudgetReportContext();

    const handleRefreshReport = async () => {
        const reportType = viewType === TYPE_SUMMARY ? 'summary' : 'detailed';
        try {
            await refreshReport(reportType);
            toast.info($t('Report generation has been queued. You will be notified when it is ready.'));
        } catch (e) {
            toast.error($t('Failed to queue report generation. Please try again.'));
        }
    };

    const currentReportType = viewType === TYPE_SUMMARY ? 'summary' : 'detailed';
    const currentGenerationTime = generationTime[currentReportType];
    const currentIsGenerating = isGenerating[currentReportType];

    const ReportActions = () => (
        <div className="tw-flex tw-items-center tw-gap-x-3">
            {currentGenerationTime && (
                <div className="tw-text-sm tw-text-charcoal-50">
                    {$t('Generated')}: {format(new Date(currentGenerationTime), 'yyyy-MM-dd HH:mm')}
                </div>
            )}
            <Button onClick={handleRefreshReport} variant="outline" size="sm" disabled={currentIsGenerating} className="tw-flex tw-items-center tw-gap-x-1.5">
                <RefreshIcon className={currentIsGenerating ? 'tw-animate-spin' : ''} />
                {currentIsGenerating ? $t('Generating...') : $t('Refresh Report')}
            </Button>
        </div>
    );

    return (
        <div>
            {viewType === TYPE_SUMMARY && !!summary && <ActualVsBudgetReportSummaryTable Actions={<ReportActions />} />}
            {viewType === TYPE_DETAILED &&
                !!details &&
                (module === TYPE_EVENT ? (
                    <ActualVsBudgetReportDetailedTable Actions={<ReportActions />} />
                ) : (
                    <DepartmentActualVsBudgetReportDetailedTable Actions={<ReportActions />} />
                ))}
        </div>
    );
};

export default ActualVsBudgetReportTable;
